// Cardiac subsection form field enum
export enum CardiacFormField {
  CARDIAC_CARDIOVASCULAR_WNL = 'medicalBackground/cardiac/cardiovascularWnl',
  CARDIAC_CARDIOVASCULAR_FACTORS = 'medicalBackground/cardiac/cardiovascularFactors',
  CARDIAC_HEART_SOUNDS = 'medicalBackground/cardiac/heartSounds',
  CARDIAC_SYSTEM_SUMMARY = 'medicalBackground/cardiac/systemSummary'
}
